import { Navigate, Outlet, Route, Routes } from "react-router-dom"
import { adminRoutes } from "./adminRoutes"
import { renderRoutes } from "~/utils/routes"
import { useDynamicFormsSchema } from "~/hooks/useDynamicFormsSchema"
import slugify from "~/utils/admin/slugify"
import { ROUTER_PATHS } from "./constants"
import DynamicFormRoute from "~/components/ui/Admin/Form/DynamicFormRoute"
import DynamicFormEdit from "~/components/ui/Admin/Form/DynamicFormEdit"
import eAdminUserRole from "~/enums/eAdminUserRole"
import Unauthorized from "~/components/Admin/Unauthorized"
import { AdminLayout } from "~/layouts/AdminLayout"

export type AppRoute = {
  path: string
  component: JSX.Element
}

export interface RouteConfig {
  path?: string
  component?: JSX.Element
  layout?: JSX.Element
  routes?: RouteConfig[]
  roles?: eAdminUserRole[]
}

export const AppRoutes = () => {
  const { index: { data: dynamicFormSchema, isError } } = useDynamicFormsSchema()
  const dynamicRoutes: RouteConfig[] = dynamicFormSchema?.models ? dynamicFormSchema.models.map((schema) => ({
    path: `${ROUTER_PATHS.ADMIN_SETTINGS}/${slugify(schema.model)}`,
    component: <DynamicFormRoute schema={schema} />,
  })) : []
  
  const dynamicEditRoutes: RouteConfig[] = dynamicFormSchema?.models ? dynamicFormSchema.models.map((schema) => ({
    path: `${ROUTER_PATHS.ADMIN_SETTINGS}/${slugify(schema.model)}/:id`,
    component: <DynamicFormEdit />,
  })) : []
  
  if (adminRoutes[0]?.routes?.[3]?.routes && !isError && dynamicFormSchema?.models) {
    adminRoutes[0].routes[3].routes.push(...dynamicRoutes, ...dynamicEditRoutes)
  } else if (isError) {
    console.error("Failed to load dynamic forms schema due to authorization or other error.")
  }
  
  const redirectRoute = () => {
    return "/"
  }

  return (
    <Routes>
      <Route path="/" element={<Navigate to={redirectRoute()} />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route path="unauthorized" element={<Unauthorized />} />
      </Route>
      <Route path="*" element={<></>} />
      {renderRoutes(adminRoutes)}
    </Routes>
  )
}
